import React from 'react'
import Projects from './Projects'
import dashboardImage from '../assets/dashboardImage.png'
import gamenationImage from '../assets/gameNationImage.jpeg'
import MokImage from '../assets/MokImage.jpeg'
import flattImage from '../assets/flattImage.png'

const ProjectSection = () => {
  return (
    <div id="works">
        <Projects
        project="Mokrimo music"
        projectDescription="Mokrimo is a music streaming platform that allows users to listen to music and podcasts for free. It is a platform that allows users to listen to music and podcasts for free. It is a platform that allows users to listen to music and podcasts for free. Please click on proceed!!!"
        projectUrl="https://mok-music.netlify.app/"
        imgSrc={MokImage}
        />
        <Projects
          project="Gamenation Community"
          projectDescription="Gamenation is a community of gamers that allows users to play games with other gamers. It is a platform that connects gamers from all over the world."
          projectUrl="https://gamenation.vercel.app/"
          imgSrc={gamenationImage}
        />
        <Projects
        project="Logistic Company Dashboard"
        projectDescription="Logistic Company Dashboard is a dashboard that allows users to track their shipments.
        It is used to monitor import and export shipments. Truck drivers and warehouse workers can use it to track shipments."
        projectUrl="https://tuasegun-dashboard.netlify.app"
        imgSrc={dashboardImage}
        />
        <Projects 
        project="Flatt ride hailing"
        projectDescription="Flatt is a ride hailing platform that allows users to book rides. It is a platform that allows users to book rides. This is just the landing page concept."
        projectUrl="https://flatttest.netlify.app/" 
        imgSrc={flattImage}
        />
    </div>
  )
}

export default ProjectSection